import { formatPeso } from '@tahi/core';
import { Link } from 'react-router';
import type { TileSize } from '../../../tiles/registry';
import { Money } from '../../../ui';
import { spokenPeso } from '../../../ui/spokenPeso';
import { copy } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { useQuitOverview } from '../hooks';
import { FOCUS } from '../styles';

/** Money saved against the baseline since the plan started; a negative number is said plainly. */
export function MoneySavedTile({ size }: { size: TileSize; config: unknown }) {
  const q = useQuitOverview();
  const o = q?.overview;
  if (!o) return <p className="text-sm text-muted">{q ? copy.needPlan : copy.loading}</p>;
  if (!o.hasPrice) {
    return (
      <div role="group" aria-label={`${copy.moneySavedTitle}, ${copy.noPrice}`}>
        <p className="text-sm text-muted">{copy.noPrice}</p>
      </div>
    );
  }
  const ahead = o.saved >= 0;
  const amount = Math.abs(o.saved);
  const name = `${copy.moneySavedTitle}, ${spokenPeso(amount)} ${ahead ? 'since you started' : 'more than your usual'}`;
  return (
    <div role="group" aria-label={name} className="flex flex-col gap-1">
      <Link to={QUIT_BASE} className={`block ${FOCUS}`}>
        <Money minor={amount} className="block text-[32px] leading-tight" />
      </Link>
      <p className="text-sm text-muted">
        {ahead ? copy.savedSince : copy.overUsual(formatPeso(amount))}
      </p>
      {size === 'wide' ? (
        <p className="text-sm text-muted">
          {copy.thisWeek} <Money minor={o.spentWeek} /> · {copy.allTime}{' '}
          <Money minor={o.spentAll} />
        </p>
      ) : null}
    </div>
  );
}
